// import moment from 'moment'
import React from 'react'
import { translate } from '../../utils/useful'
// import { checkTextTranslation } from '../../utils/useful'
let moment = require('jalali-moment');

class TableDateInput extends React.Component {
    state = {
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su',],
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {

        let variables = this.props.variables

        let format = 'DD MMM YYYY'

        if (variables?.appletSettings?.calendarType == 'jalali') {
            format = 'jYYYY/jM/jD'
        }
        if (this.props.header.information?.showHour) {
            format = format + ' hh:mm'
        }
        let color = null

        let date

        if (this.props.data) {

            if (moment(this.props.data).isValid()) {
                date = moment(this.props.data)
            } else if (moment(Number(this.props.data)).isValid()) {
                date = moment(Number(this.props.data))
            }

            if (date) {
                if (variables?.appletSettings?.calendarType == 'jalali') {
                    date = date.locale('fa')
                }
                date = date.format(format)

            } else {
                date = translate("Invalid Date")

            }
        }


        return (
            <div className="w-100 h-100 flexcc" style={{ color }}>


                <div className='w-100 flexc'>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{date}</p>
                </div>
                {/* {(this.props.data && this.props.data != '' && moment(Number(this.props.data)).isValid()) ? (
                    <div className='w-100 flexc'>
                        <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{moment(Number(this.props.data)).format(format)}</p>
                    </div>
                ) : (
                    <div className='flexc w-100'>
                        {(!moment(Number(this.props.data)).isValid()) ? (
                            <p className=" w-100 " style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{translate("Invalid Date")}</p>
                        ) : (
                            <p className=" w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{translate("No date")}</p>
                        )}
                    </div>
                )} */}
            </div>
        )
    }
}

export default TableDateInput;